import * as styles from './styles'

import { ReactComponent as BurgerIcon } from '../../assets/burger.svg'
import { ReactComponent as PizzaIcon } from '../../assets/pizza.svg'
import { ReactComponent as DrinkIcon } from '../../assets/copo-canudo.svg'
import { ReactComponent as IceCraemIcon } from '../../assets/ice-cream.svg'

import menuImg from '../../assets/menu.svg'
import { useState } from 'react'
import { NavLink } from 'react-router-dom'

export function SideBar() {
  const [menuOpen, setMenuopen] = useState(false)

  function handleOpen() {
    setMenuopen((prev) => !prev)
  }
  return (
    <styles.container is_menu_open={menuOpen}>
      <button type='button' onClick={handleOpen}>
        <img src={menuImg} alt='abrir e fechar menu' />
      </button>
      <nav>
        <ul>
          <li>
            <NavLink to='/'>
              <BurgerIcon />
              <span>Hambúrgers</span>
            </NavLink>
          </li>
          <li>
            <NavLink to='/pizzas'>
              <PizzaIcon />
              <span>Pizza</span>
            </NavLink>
          </li>
          <li>
            <NavLink to='/drinks'>
              <DrinkIcon />
              <span>Bebidas</span>
            </NavLink>
          </li>
          <li>
            <NavLink to='/ice-creams'>
              <IceCraemIcon />
              <span>Sorvete</span>
            </NavLink>
          </li>
        </ul>
      </nav>
    </styles.container>
  )
}
